import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "./index";
import { colores, bkCabGrilla, clCabGrilla, bkCeldaGrilla, clCeldaGrilla, sizeCelda, bkSeleccion, sizeCabezal, bbottomGrilla } from "./general"
import CRUDriesgo from "./CRUDriesgo";
import add from "./img/add.png";

export default function Riesgos({ filtro }) {
  let { firebase } = useContext(AppContext);
  if (!filtro) filtro = "Todos"
  let color = colores["riesgos"];
  const [crudRiesgo, setCrudRiesgo] = useState(false);
  const [riesgo, setRiesgo] = useState(null);

  useEffect(() => {
    document.getElementById("htmlTituloPagS").innerHTML = "Riesgos";
  }, []);

  return (
    <div style={SadmRiesgos}>
      <div style={Sriesgos}>
        <div style={Scabezal}><div>Riesgos</div><div></div></div>
        <div style={SlistaRiesgos}>
          {firebase.riesgos(firebase.proyectoActivo.proyecto.id, filtro, true).map((r) => (
            <div
              style={SdetalleRiesgo}
              key={r.id}
              onMouseEnter={(e) => (e.currentTarget.style.background = bkSeleccion)}
              onMouseLeave={(e) => (e.currentTarget.style.background = bkCeldaGrilla)}
              onClick={() => {
                setRiesgo(r);
                setCrudRiesgo(!crudRiesgo);
              }}
            >
              <div style={Scelda}>{r.descripcion.substr(0, 190)}</div>
              <div style={Scelda}>
                <i className="material-icons icono20" style={{ color: `${color[r.prioridad]}` }}>
                  flag
              </i>
              </div>
            </div>
          ))}
        </div>
        <div style={Sadd}>
          <img
            src={add}
            alt="+"
            title="Agregar"
            height="30px"
            width="30px"
            style={{ display: "block", textAlign: "right", cursor: "pointer", marginTop: "10px" }}
            onClick={() => {
              setRiesgo(null);
              setCrudRiesgo(!crudRiesgo);
            }}
          ></img>
        </div>
      </div>
      <div style={Scrud}>
        {crudRiesgo && <CRUDriesgo riesgo={riesgo} set={setCrudRiesgo} />}
      </div>
    </div>
  );
}
const SadmRiesgos = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  width: "93.5vw",
  marginTop: "15px"
}

const Sriesgos = {
  width: "53%",
}

const Scrud = {
  width: "38%",
}

const Scabezal = {
  display: "grid",
  gridTemplateColumns: " 95% 5%",
  background: bkCabGrilla,
  color: clCabGrilla,
  fontSize: sizeCabezal,
  fontWeight: 700,
  padding: "8px 0px 8px 3px",
};

const SlistaRiesgos = {
  overflowY: "auto",
  maxHeight: "70vh",
  marginTop: "6px",
  cursor: "pointer"
};

const SdetalleRiesgo = {
  display: "grid",
  gridTemplateColumns: " 95% 5%",
  height: "6.8vh",
  marginBottom: "2px",
  background: bkCeldaGrilla,
  overflow: "hidden"
};

const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "5px 2px 5px 2px",
  fontSize: sizeCelda,
  color: clCeldaGrilla
};

const Sadd = {
  display: "flex",
  justifyContent: "flex-start",
};
